'use client'

/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react'
import Image from 'next/image'
import { useProductContext } from '@context/ProductContext/ProductContext'
import assetLoader from '@utils/internalImageLoader'

import styles from './accordion.module.scss'

const AccordionIcons = ({ accordionItem }) => {
  const { setAccordianItem } = useProductContext()

  const handleAccordion = () => {
    setAccordianItem(accordionItem)
  }
  return (
    <div className={styles.toggleButton} onClick={() => {}} onKeyDown={handleAccordion}>
      <Image
        src={`${assetLoader()}/images/accordion-plus-icon.svg`}
        alt="Accordion plus sign"
        width={20}
        height={20}
        className={styles.plusIcon}
        loading="lazy"
        decoding="async"
      />
      <Image
        src={`${assetLoader()}/images/accordion-minus-icon.svg`}
        alt="Accordion negative sign"
        width={20}
        height={20}
        className={styles.minusIcon}
        loading="lazy"
        decoding="async"
      />
    </div>
  )
}

export default AccordionIcons
